interface BellWithCheckmarkSVGProps {
  color: string;
  style: React.CSSProperties;
}

const BellWithCheckmarkSVG = ({ color, style }: BellWithCheckmarkSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="45"
    height="46"
    viewBox="0 0 45 46"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30.3044 12.5006C28.5908 9.40174 25.6661 7.68828 22.5 7.68828C17.4989 7.68828 13.125 11.9176 13.125 19.1597C13.125 25.1329 11.8017 28.8911 9.29716 31.6754C8.90331 32.1133 8.05513 32.9176 7.5 33.4373V34.5135H37.5V33.4365C36.9405 32.9106 36.0949 32.1056 35.7003 31.6653C35.0544 30.9443 34.4871 30.1589 34.0007 29.2879L36.7892 26.4375C37.2299 27.4677 37.7913 28.3245 38.4663 29.0779C38.7792 29.4272 39.6305 30.2296 40.1944 30.7611C40.4544 31.0061 40.6532 31.1936 40.7101 31.2525L41.25 31.8119V38.3452H29.7644C29.2953 40.2319 28.139 41.8844 26.4146 42.9596C24.011 44.4583 20.989 44.4583 18.5854 42.9596C16.6314 41.7412 15.5509 40.3799 15.165 38.3452H3.75V31.8119L4.28993 31.2525C4.35261 31.1879 4.5599 30.9931 4.82748 30.7416C5.39305 30.21 6.228 29.4251 6.53617 29.0825C8.37934 27.0334 9.375 24.2058 9.375 19.1597C9.375 11.3606 13.5663 5.97482 19.0037 4.36148C19.2004 3.84291 19.5107 3.36085 19.9322 2.95621C21.3755 1.57059 23.6245 1.57059 25.0678 2.95621C25.4902 3.36174 25.801 3.84503 25.9976 4.3649C28.7805 5.1953 31.2395 7.01766 32.9757 9.64383L30.3044 12.5006ZM19.085 38.3442C19.3499 38.8477 19.8014 39.2279 20.5388 39.6878C21.7431 40.4386 23.2571 40.4386 24.4613 39.6878C25.0189 39.3401 25.4547 38.88 25.7564 38.3442H19.085ZM36.1742 13.9784L28.125 22.2065L23.8258 17.8118L21.1742 20.5223L28.125 27.6276L38.8258 16.689L36.1742 13.9784Z"
      fill={color}
    />
  </svg>
);

export default BellWithCheckmarkSVG;
